<micro-select-combo #sel
              placeholder="Short URL Carrier Type"
              [mode]="mode"
              [(id)]="surlCarrierTypeId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
